<template>
  <div class="banner">
    <div class="banner-wrapper">
      <div class="banner-img">
        <img src="../../../assets/images/banner/banner.png" alt="" />
      </div>
      <div class="flex common-margin">
        <img src="../../../assets/images/other/ptgn.png" alt="" />
      </div>
      <div class="flex">
        <img
          :src="TGImg"
          alt=""
          @mouseenter="changeFunSrc(1, 'hover')"
          @mouseleave="changeFunSrc(1, '')"
          @click="goUrl('/sunShine/port')"
        />
        <img
          :src="SWImg"
          alt=""
          @mouseenter="changeFunSrc(2, 'hover')"
          @mouseleave="changeFunSrc(2, '')"
          @click="goUrl('/sunShine/tax')"
        />
        <img
          :src="JHImg"
          alt=""
          @mouseenter="changeFunSrc(3, 'hover')"
          @mouseleave="changeFunSrc(3, '')"
          @click="goUrl('/sunShine/settlement')"
        />
        <img
          :src="RZImg"
          alt=""
          @mouseenter="changeFunSrc(4, 'hover')"
          @mouseleave="changeFunSrc(4, '')"
          @click="goUrl('/sunShine/financing')"
        />
      </div>
      <div class="flex common-margin">
        <img src="../../../assets/images/other/ptrz.png" alt="" />
      </div>
      <div class="flex-enter flex-bottom">
        <img
          :src="ZXImg"
          alt=""
          @mouseenter="changeEnterSrc(1, 'hover')"
          @mouseleave="changeEnterSrc(1, '')"
          @click="goUrl('/sunShine/conduct')"
        />
        <img src="../../../assets/images/enterImg/next.png" alt="" />
        <img
          :src="FAImg"
          alt=""
          @mouseenter="changeEnterSrc(2, 'hover')"
          @mouseleave="changeEnterSrc(2, '')"
          @click="goUrl('/sunShine/consult')"
        />
        <img src="../../../assets/images/enterImg/next.png" alt="" />
        <img
          :src="BLImg"
          alt=""
          @mouseenter="changeEnterSrc(3, 'hover')"
          @mouseleave="changeEnterSrc(3, '')"
          @click="goUrl('/sunShine/customize')"
        />
        <img src="../../../assets/images/enterImg/next.png" alt="" />
        <img
          :src="YWImg"
          alt=""
          @mouseenter="changeEnterSrc(4, 'hover')"
          @mouseleave="changeEnterSrc(4, '')"
          @click="goUrl('/sunShine/qualifications')"
        />
      </div>
      <div class="flex common-margin">
        <img src="../../../assets/images/other/xgdw.png" alt="" />
      </div>
      <div class="companyBox">
        <div class="company" v-for="item in companyTypeArr" :key="item.id">
          <img :src="item.logoUrl" @click="toPath(item.website)">
        </div>
      </div>
      <div v-show="isShow" @click="huadong">
<!--        <div class="iconfont icon-tubiaozhizuo-     jiantou"></div>-->
<!--        <div class="iconfont icon-tubiaozhizuo-     jiantou2"></div>-->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      tableData: [{
        date: '2023--07-09',
        name: '1.7000',
        address: '美国',
        tag: '上涨'
      }, {
        date: '2023--07-09',
        name: '7.1872',
        address: '法国',
        tag: '下跌'
      }, {
        date: '2023--07-09',
        name: '1.1872',
        address: '新加坡',
        tag: '上涨'
      }, {
        date: '2023--07-09',
        name: '0.1872',
        address: '印度',
        tag: '下跌'
      },{
        date: '2023--07-09',
        name: '0.1762',
        address: '阿根廷比索',
        tag: '上涨'}
        ,{
          date: '2023--07-09',
          name: '0.8980',
          address: '美国瑞士法郎',
          tag: '上涨'}
        ,{
          date: '2023--07-09',
          name: '7.8172',
          address: '美元港元',
          tag: '上涨'}
        ,{
          date: '2023--07-09',
          name: '1303.7700',
          address: '美元韩元',
          tag: '上涨'}
        ,{
          date: '2023--07-09',
          name: '90.7260',
          address: '美元俄罗斯卢布',
          tag: '上涨'}
      ],
      ratedata:[],
      ruleForm: {
        password: undefined,
        userName: undefined,
        nickName: undefined,
        phonenumber: undefined,
        email: undefined,
        deptId: 101,
        sex: "0",
        status: "0",
        remark: undefined,
        postIds: [2],
        roleIds: [2]
      },
      rules: {
        password: [
          {
            required: true,
            trigger: "blur",
            min: 6,
            message: "密码最少需要6位数"
          }
        ],
        userName: [
          { required: true, message: "请输入注册企业名称", trigger: "blur" }
        ],
        nickName: [
          { required: true, message: "请输入您的昵称", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      companyTypeArr:[],
      centerDialogVisible: false, //企业注册弹框默认值
      idx: 0,
      isShow: true,
      show: false,
      TGImg: require(`../../../assets/images/funImg/TG.png`),
      SWImg: require(`../../../assets/images/funImg/sw.png`),
      JHImg: require(`../../../assets/images/funImg/jh.png`),
      RZImg: require(`../../../assets/images/funImg/rz.png`),
      ZXImg: require(`../../../assets/images/enterImg/ZX.png`),
      FAImg: require(`../../../assets/images/enterImg/FA.png`),
      BLImg: require(`../../../assets/images/enterImg/bl.png`),
      YWImg: require(`../../../assets/images/enterImg/yw.png`)
    };
  },
  methods: {
    resetDateFilter() {
      this.$refs.filterTable.clearFilter('date');
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    getData() {
      // 模拟异步获取最新汇率数据，并更新到 data 中
      // 替换下方的示例数据为实际的汇率数据获取逻辑
      setTimeout(() => {
        const rates = [
          '1 USD = X CNY',
          '1 EUR = X CNY',
          '1 GBP = X CNY',
          '1 JPY = X CNY',
          '1 CAD = X CNY',
          '1 AUD = X CNY',
          '1 SGD = X CNY',
          '1 CHF = X CNY',
          '1 KRW = X CNY',
          '1 INR = X CNY'
        ];
        this.ratedata = rates;
      }, 500);
    },
    changeFunSrc(key, way) {
      let tempStr = way === "hover" ? "Hover" : "";
      switch (key) {
        case 1:
          this.TGImg = require(`../../../assets/images/funImg/TG${tempStr}.png`);
          break;
        case 2:
          this.SWImg = require(`../../../assets/images/funImg/sw${tempStr}.png`);
          break;
        case 3:
          this.JHImg = require(`../../../assets/images/funImg/jh${tempStr}.png`);
          break;
        case 4:
          this.RZImg = require(`../../../assets/images/funImg/rz${tempStr}.png`);
          break;
      }
    },
    changeEnterSrc(key, way) {
      let tempStr = way === "hover" ? "Hover" : "";
      switch (key) {
        case 1:
          this.ZXImg = require(`../../../assets/images/enterImg/ZX${tempStr}.png`);
          break;
        case 2:
          this.FAImg = require(`../../../assets/images/enterImg/FA${tempStr}.png`);
          break;
        case 3:
          this.BLImg = require(`../../../assets/images/enterImg/bl${tempStr}.png`);
          break;
        case 4:
          this.YWImg = require(`../../../assets/images/enterImg/yw${tempStr}.png`);
          break;
      }
    },
    // 关闭注册用户模态框清空填写数据
    closeDialog(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.password = "";
      this.ruleForm.userName = "";
      this.ruleForm.nickName = "";
      this.ruleForm.phonenumber = "";
      this.ruleForm.email = "";
    },
    // 提交注册用户数据
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.centerDialogVisible = false;
          axios
            .post("api/system/user/up", this.ruleForm)
            .then(function(response) {
              console.log(response);
            })
            .catch(function(err) {
              console.log("error");
            });
        } else {
          console.log("失败失败!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      if (scrollTop >= 300) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    huadong() {
      window.scrollTo({
        top: 800,
        behavior: "smooth"
      });
    },
    goUrl(url) {
      this.$router.push(url);
      document.documentElement.scrollTop = 0;
    },
    getCompanyList(){
      let that = this
      axios
        .get(`http://121.40.212.122:8091/product/related-unit/list`)
        // .get(`http://localhost:8091/product/related-unit/list`)
        .then((response) => {
          that.companyTypeArr = response.data.data
        });
    },
    toPath(url){
      if (!url) {
        return
      }
      window.open(url,'_blank')
    }
  },
  mounted() {
//     // 获取容器元素
//     const container = document.querySelector('.scrollable-list');
//
// // 定义每次滚动的距离（根据实际内容高度调整）
//     const scrollDistance = 1;
//
// // 定义滚动间隔时间（单位：毫秒）
//     const scrollInterval = 50;
//
// // 定义滚动方向（向上滚动或向下滚动）
//     let scrollDirection = 'up';
//
// // 定义滚动函数
//     function scrollList() {
//       if (scrollDirection === 'up') {
//         container.scrollTop += scrollDistance;
//       } else {
//         container.scrollTop -= scrollDistance;
//       }
//
//       // 判断是否到达边界，如果到达边界则改变滚动方向
//       if (container.scrollTop === 0) {
//         scrollDirection = 'up';
//       } else if (container.scrollTop >= (container.scrollHeight - container.offsetHeight)) {
//         scrollDirection = 'down';
//       }
//     }
//
// // 开始自动翻滚
//     setInterval(scrollList, scrollInterval);
//     window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    // 模拟获取汇率数据
    this.getData();
    // 每 5 秒更新一次汇率数据
    setInterval(() => {
      this.getData();
    }, 5000);
    // this.idx = parseInt(localStorage.getItem('flag'));
    this.idx = this.$store.state.flag;
    localStorage.setItem("flag", 0);
    this.getCompanyList()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
    localStorage.setItem("flag", 0);
  }
};
</script>
<style scoped>
.banner-img {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 180px;
  margin-bottom: 80px;
}

.icon-tubiaozhizuo-::before {
  font-size: 30px;
}

.jiantou {
  position: fixed;
  color: yellow;
  bottom: 60px;
  left: 50%;
}

.jiantou2 {
  position: fixed;
  color: yellow;
  bottom: 50px;
  left: 50%;
}

.common-margin {
  margin: 40px 0;
  box-sizing: border-box;
}

.common-margin-bottom {
  margin-bottom: 20px;
}

.flex-enter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-enter img {
  margin: 0 20px;
}

.flex > img {
  margin: 0 63px;
}
.flex-bottom {
  margin-bottom: 150px;
}
.rate-scroll {
  height: 300px; /* 设置滚动区域高度 */
}

.centered-list {
  display: flex;
  justify-content: center;
}

.centered-list::before,
.centered-list::after {
  content: '';
  flex-grow: 1;
}

.centered-list > * {
  flex-shrink: 0;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.scrollable-list {
  height: 400px; /* 设置容器的固定高度 */
  overflow: hidden; /* 隐藏溢出内容 */
}

li {
  line-height: 30px;
  border-bottom: 1px solid #eee;
}
.companyBox {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 15px;
  margin-bottom: 150px;
}

.company {
  width: calc(25% - 15px * 3 / 4);
  aspect-ratio: 2/1; /* 长方形容器 */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #b7b7b7;
}

.company img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 或使用contain */
  transition: transform 0.3s;
}

.company:hover img {
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/components/children/SunShine/HomePage.vue